import { TimelinePipe } from "@pnp/core";
import { Picker } from "../Picker";

export function ResolveWithPicks(): TimelinePipe<Picker> {

    return (instance: Picker) => {
        instance.on.pick(async function (this: Picker, data) {
            // @ts-ignore
            this.emit[this.InternalResolveEvent](data);
        });

        return instance;
    };
}
